interface LineChartIconProps {
  size?: number;
  className?: string;
}

export default function LineChartIcon({ size = 36, className = '' }: LineChartIconProps) {
  return (
    <span className={className}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={size}
        viewBox='0 0 24 24'
        fill='none'
        aria-hidden='true'
      >
        {/* Y axis (vertical) */}
        <path
          d='M3 3V21'
          stroke='currentColor'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        {/* X axis (horizontal) */}
        <path
          d='M3 21H21'
          stroke='currentColor'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        {/* Graph line */}
        <path
          d='M19 9L14 14L10 10L7 13'
          stroke='currentColor'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </span>
  );
}
